import { render } from "./MeditatingSVG.vue?vue&type=template&id=e0ca2602"
const script = {}

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__